import { useState } from 'react';

import { render as renderCustom } from '../entry';

import { client, ClientProvider } from "@magalu/rave/graphql";
import { ConfigProvider } from "@magalu/rave/config/Provider";


import clientConfig from '../containers/client-config';


const CustomRender = ({ Component, pageProps }) => {
  return renderCustom({ Component, pageProps });
};

export const withRaveContexts = (children, clientEnvs = {}) => {
  const [configEnvs] = useState({ client: { ...clientConfig, ...clientEnvs } });
  let clientProviderParams = {};

  clientProviderParams = {
    config: {
      ...({
  "host": "https://federation.magazineluiza.com.br",
  "timeout": 5000,
  "credentials": "include",
  "serverDefaultOptions": {
    "query": {
      "errorPolicy": "all",
      "fetchPolicy": "cache-first"
    },
    "watchQuery": {
      "errorPolicy": "all",
      "fetchPolicy": "cache-first"
    },
    "mutate": {
      "errorPolicy": "all",
      "fetchPolicy": "no-cache"
    }
  }
} || {}),
      ...(configEnvs?.client?.datasource?.graphql || {})
    },
  };
  return (
    <ClientProvider {...clientProviderParams}>
      <ConfigProvider config={configEnvs}>{children}</ConfigProvider>
    </ClientProvider>
  );
};

export default function CustomApp({ Component, pageProps = {} }) {
  const clientEnvs = pageProps.clientConfig;
  let parsedPageProps = {...pageProps};
    parsedPageProps = {
      ...pageProps,
      ...{
  "manifest": {
    "isMiniApp": false,
    "useTypescript": true
  }
}
    }

    return withRaveContexts(<CustomRender Component={Component} pageProps={parsedPageProps} />, clientEnvs);
};
